module.exports = __webpack_public_path__ + "img/my-people-will-get-back.090b9800.jpg";